// extracted by mini-css-extract-plugin
export default {"MainImage":"MainImage_MainImage__gRCll"};